var map = {
	"./music-instructions.json": 3006,
	"./music-library.json": 3007,
	"./music-progression.json": 3008,
	"./startSourcesAdvanced.json": 3009,
	"./startSourcesSimple.json": 3010,
	"./startSourcesSimple2.json": 3011,
	"./startSourcesTracks.json": 3012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2394;